
export const randomChangeColor = (() => {
  let state = true

  return (color1, color2) => {
    state = !state

    if (state) {
      return color1
    }

    return color2
  }

})()
